import Vue from 'vue'
import App from './buybuttonCompact.vue'
import axios from 'axios';

Vue.config.productionTip = false
if (typeof window.buybuttons == 'undefined') {
  window.buybuttons = [];
}
window.axios = require('axios');
if (document.querySelectorAll(".buyButtonVue")[0].dataset.sub == "false") {
  document.querySelectorAll(".buyButtonVue").forEach(function (btn) {
    window.buybuttons.push({
      id: parseInt(btn.dataset.id), instance: new Vue({
        render: h => h(App),
        name: btn.dataset.productname,
        data: {
          id: parseInt(btn.dataset.id),
          quantity: btn.dataset.quantity != 0 ? btn.dataset.quantity : 0,
          availability: btn.dataset.availability == "" ? 5 : btn.dataset.availability,
          backorder: backorder,
          sub: (btn.dataset.sub == "true"),
          preorder: preorder,
          productname: btn.dataset.productname,
          pointshop: (btn.dataset.ispointshop == "true"),
          iscompany: (btn.dataset.iscompany == "true"),
          display: JSON.parse(btn.dataset.display),
          hideprice: JSON.parse(btn.dataset.hideprice),
          language: webshop_compact_translations,
          iscompany: (btn.dataset.iscompany == "Y"),
          isAdmin: (btn.dataset.admin == "true"),
          isLocalAdmin:(btn.dataset.localadmin == "true"),
          turbocheckout: (btn.dataset?.turbocheckout == "true"),
          flaptype: (btn.dataset.flaptype)
        }
      }).$mount(btn)
    })
  })
} else {
  let btn = document.querySelectorAll(".buyButtonVue")[0];
  axios.get(`${window.basedir}/ajaxRequestServlet?mode=GetProduct&isSpecial=true&payload={productID:${btn.dataset.id}, isPointShop: ${(btn.dataset.ispointshop == "true")}}`).then(async res => {
    window.buybuttons.push({
      id: parseInt(btn.dataset.id), instance: new Vue({
        render: h => h(App),
        name: res.data.name,
        data: {
          productdata: await (async () => (await axios.get(`${window.basedir}/ajaxRequestServlet?mode=GetSubProducts&productId=${res.data.products[0].productId}&isPointshop=${(btn.dataset.ispointshop == "true")}`)))(),
          id: res.data.products[0].productId,
          quantity: res.data.products[0].quantity != 0 ? res.data.quantity : 0,
          availability: res.data.products[0].availability == "" ? 5 : res.data.availability,
          backorder: res.data.products[0].isBackorderAllowed,
          preorder: true,
          sub: (btn.dataset.sub == "true"),
          productname: res.data.products[0].productName,
          pointshop: (btn.dataset.ispointshop == "true"),
          iscompany: (btn.dataset.iscompany == "true"),
          display: JSON.parse(btn.dataset.display),
          hideprice: JSON.parse(btn.dataset.hideprice),
          language: webshop_compact_translations,
          iscompany: (btn.dataset.iscompany == "Y"),
          isAdmin: (btn.dataset.admin == "true"),
          isLocalAdmin:(btn.dataset.localadmin == "true"),
          turbocheckout: (btn.dataset?.turbocheckout == "true"),
          flaptype: (btn.dataset.flaptype)
        }
      }).$mount(btn)
    })
  })
}



/* let btn = document.querySelectorAll(".buyButtonVue")[0];
axios.get(`${window.basedir}/ajaxRequestServlet?mode=GetProduct&isSpecial=true&payload={productID:${btn.dataset.id}, isPointShop: 'N'}`).then(async res => {
  console.log(res.data)
  new Vue({
    render: h => h(App),
    name: res.data.name,
    data: {
      productdata: await (async () => (await axios.get(`${window.basedir}/ajaxRequestServlet?mode=GetSubProducts&productId=${res.data.productID}&isPointshop=${(btn.dataset.ispointshop == "true")}`)))(),
      id: res.data.productID,
      quantity: res.data.quantity != 0 ? res.data.quantity : 0,
      availability: res.data.availability == "" ? 5 : res.data.availability,
      backorder: res.data.isBackorderAllowed,
      preorder: true,
      productname: res.data.productName,
      pointshop: (btn.dataset.ispointshop == "true"),
      iscompany: (btn.dataset.iscompany == "true"),
      display: JSON.parse(btn.dataset.display),
      hideprice: JSON.parse(btn.dataset.hideprice),
      language: JSON.parse(btn.dataset.language),
      iscompany: (btn.dataset.iscompany == "Y")
    }
  }).$mount(btn)
})
 */